import React, { createRef, useEffect, useState } from 'react'
import Theme from '../../../../../Theme'

type Props = {
    name: string
    position: { x: number, y: number }
    selectedLocation: string | null
    setHeading: any
    setHotspotPosition: any
    openPopup: () => void
}

const transition = 'all 1000ms ease-in-out'

export default function Hotspot({ position, name, openPopup, selectedLocation, setHeading, setHotspotPosition }: Props) {
    const [onHover, setHover] = useState(false)
    const { x, y } = position

    let fillColor = Theme.colors.BrandOrange
    let shadowColor = Theme.colors.White

    if (!!selectedLocation && selectedLocation === name) {
        shadowColor = Theme.colors.BrandOrange

    } else if (!!selectedLocation && selectedLocation !== name) {
        fillColor = Theme.colors.BrandBlue
    }

    if (onHover)
        fillColor = Theme.colors.BrandOrange

    function onClickPotato(e: React.MouseEvent) {
        e.stopPropagation()
        openPopup()
        setHover(false)
        // setHeading('')
    }

    const circleRef = createRef<any>()

    function randomNumber(min: number = 1000, max: number = 5000) {
        return Math.random() * (max - min) + min;
    }

    const [glow, setGlow] = useState(false)
    useEffect(() => {

        function start() {
            setTimeout(() => {

                setGlow(true)

                setTimeout(() => {
                    setGlow(false)
                    setTimeout(start, randomNumber())
                }, 1000)

            }, randomNumber())
        }

        start()
    }, [])

    return (
        <>
            <g
                style={{ cursor: 'pointer' }}
                onMouseEnter={() => {
                    const { x, y } = circleRef.current.getBoundingClientRect()
                    setHotspotPosition({ pageX: x + 10, pageY: y + 15 })
                    setHover(true)
                    setHeading(name)
                }}
                onMouseLeave={() => {
                    setHotspotPosition()
                    setHover(false)
                    setHeading()
                }}
                onClick={onClickPotato}
            >
                <circle
                    cx={x}
                    cy={y}
                    r={glow ? 10.5 : 9.5}
                    transform={`rotate(6.796 ${x} ${y})`}
                    fill={shadowColor}
                    fillOpacity={0.4}
                    filter={`url(#${(name && name.replaceAll) ? name.replaceAll(' ', '-') : ''})`}
                    style={{ transition }}
                />
                <circle
                    cx={x}
                    cy={y}
                    ref={circleRef}
                    r={onHover ? 13.5 : glow ? 5.5 : 3.867}
                    transform={`rotate(6.796 ${x} ${y})`}
                    fill={fillColor}
                    stroke={Theme.colors.White}
                    strokeWidth={onHover ? 0 : 0.733}
                    style={{ transition }}
                />
            </g>
            <defs>
                <filter
                    id={name && name.replaceAll ? name.replaceAll(' ', '-') : ''}
                    x={x - 12.434}
                    y={y - 9.47}
                    width={24.869}
                    height={24.869}
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity={0} result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    />
                    <feOffset dy={2.933} />
                    <feGaussianBlur stdDeviation={1.467} />
                    <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                    <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
                    <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
                </filter>


            </defs>

        </>
    )
}
